import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FiArrowLeft } from 'react-icons/fi';
import { questionsApi } from '@/services/questions';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { QuestionRowTeacher } from './QuestionRowTeacher';
import { QuestionDetailDialog } from './QuestionDetailDialog';

const PER_PAGE = 25;

export function QuestionsListTeacher({ filters, onBack }) {
  const [questions, setQuestions] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [meta, setMeta] = useState({});
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  useEffect(() => {
    setLoading(true);
    setPage(1);
    questionsApi
      .index({ filters, page: 1, perPage: PER_PAGE })
      .then(json => {
        const data = json?.data || [];
        setQuestions(data);
        setMeta(json?.meta || {});
        setHasMore(data.length >= PER_PAGE);
      })
      .catch(() => setQuestions([]))
      .finally(() => setLoading(false));
  }, [filters]);

  const loadMore = () => {
    const next = page + 1;
    questionsApi.index({ filters, page: next, perPage: PER_PAGE }).then(json => {
      const items = json?.data || [];
      setQuestions(prev => [...prev, ...items]);
      setHasMore(items.length >= PER_PAGE);
      setPage(next);
    });
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <button
          type="button"
          onClick={onBack}
          className="inline-flex items-center gap-1.5 text-sm font-bold text-neutral-700 transition-colors duration-150 hover:text-neutral-900"
        >
          <FiArrowLeft className="h-4 w-4" />
          Voltar
        </button>
        {!loading && (
          <span className="text-xs font-semibold text-neutral-500">
            {questions.length} de {meta.total_count ?? '?'} questões
          </span>
        )}
      </div>

      {loading ? (
        <div className="flex min-h-[50vh] items-center justify-center">
          <Loader />
        </div>
      ) : questions.length === 0 ? (
        <div className="flex min-h-[50vh] items-center justify-center">
          <EmptyState type="data" />
        </div>
      ) : (
        <InfiniteScroll
          dataLength={questions.length}
          next={loadMore}
          hasMore={hasMore}
          loader={<Loader />}
          className="infinite-scroll__full"
        >
          <div className="relative flex flex-col gap-3">
            {questions.map((question, index) => (
              <QuestionRowTeacher
                key={question.id}
                question={question}
                // index % PER_PAGE: reinicia o stagger da animação a cada página carregada.
                // Sem isso, o delay (250 + index * 70ms) cresce sem limite com o índice
                // acumulado da lista inteira, deixando os cards de páginas seguintes
                // invisíveis (opacity: 0) por vários segundos após o loader sumir.
                index={index % PER_PAGE}
                onView={setSelectedQuestion}
              />
            ))}
          </div>
        </InfiniteScroll>
      )}

      <QuestionDetailDialog
        question={selectedQuestion}
        onClose={() => setSelectedQuestion(null)}
      />
    </div>
  );
}
